import React,{Component} from 'react';
import './content-right-hidden-buy.css';
import RequestSample from '../../../../Forms/request-sample/request-sample';

class ContentRightHiddenBuy extends Component {
    constructor(props,context) {
        super(props, context);
        this.state = {
            smShow: false,
            lgShow: false,
            isLoaded:false,
            data:  this.props.data
        };

    }

    render() {
        let lgClose = () => this.setState({ lgShow: false });
        return(
            <div>
                <button class="spk_ana open-AddBookDialog btn_bg hidden-xs spk_ana_speak" id="d2"
                        onClick={() => this.setState({lgShow: true})} data-id={this.state.data.data.title}><i class="fa fa-download"></i> Download Free Sample NOW</button>
                <button class="spk_ana open-AddBookDialog btn_bg hidden-xs spk_ana_speak" id="d2"
                        onClick={() => this.setState({lgShow: true})} data-id={this.state.data.data.title}><i class="fa fa-headphones"></i> Speak With Analyst</button>
                <RequestSample show={this.state.lgShow} data={this.state.data} onHide={lgClose}/>
                <div class="modal fade in newsModal" id="newsModal" role="dialog" >
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">×</button>
                                <h4 class="modal-title">{this.state.data.data.title}</h4>
                            </div>
                            <div class="modal-body">
                                <div class="modal-body-inner"></div>
                                <p id="txts">Thank you for your interest in our report. Our intelligence experts will be reaching out to you with the sample document/next steps shortly.</p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }
}
export default ContentRightHiddenBuy;


// WEBPACK FOOTER //
// ./src/report-description/content/content-right/content-right-hidden-buy/content-right-hidden-buy.js